import { combineReducers } from 'redux';
import companies from './companies';

export default combineReducers({
    companies,
});
